export const ApplePayStatuses = {
    STATUS_FAILURE: 'STATUS_FAILURE',
    STATUS_SUCCESS: 'STATUS_SUCCESS'
}
